import { Icon, IconProps } from './Icon';

interface MergeIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const MergeIcon = ({ color = '#222B3A', gradient, ...props }: MergeIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M7.14286 16.75C7.71118 16.75 8.25622 16.9739 8.65809 17.3724C9.05995 17.7709 9.28571 18.3114 9.28571 18.875C9.28571 19.4386 9.05995 19.9791 8.65809 20.3776C8.25622 20.7761 7.71118 21 7.14286 21C6.57454 21 6.02949 20.7761 5.62763 20.3776C5.22576 19.9791 5 19.4386 5 18.875C5 18.3114 5.22576 17.7709 5.62763 17.3724C6.02949 16.9739 6.57454 16.75 7.14286 16.75ZM7.14286 16.75V8.25M7.14286 8.25C6.57454 8.25 6.02949 8.02612 5.62763 7.6276C5.22576 7.22909 5 6.68859 5 6.125C5 5.56141 5.22576 5.02091 5.62763 4.6224C6.02949 4.22388 6.57454 4 7.14286 4C7.71118 4 8.25622 4.22388 8.65809 4.6224C9.05995 5.02091 9.28571 5.56141 9.28571 6.125C9.28571 6.68859 9.05995 7.22909 8.65809 7.6276C8.25622 8.02612 7.71118 8.25 7.14286 8.25ZM15.7143 12.5C15.7143 13.0636 15.9401 13.6041 16.3419 14.0026C16.7438 14.4011 17.2888 14.625 17.8571 14.625C18.4255 14.625 18.9705 14.4011 19.3724 14.0026C19.7742 13.6041 20 13.0636 20 12.5C20 11.9364 19.7742 11.3959 19.3724 10.9974C18.9705 10.5989 18.4255 10.375 17.8571 10.375C17.2888 10.375 16.7438 10.5989 16.3419 10.9974C15.9401 11.3959 15.7143 11.9364 15.7143 12.5Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.14258 8.25C7.14258 9.37717 7.59411 10.4582 8.39783 11.2552C9.20156 12.0522 10.2917 12.5 11.4283 12.5H15.714"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
